import { h } from '@stencil/core/internal/client';
import { h as heading2, t as text, a as heading1 } from './parts.js';

const ErrorState = (errorMessage) => (h("main", { class: "p-4 d-flex justify-content-center text-center", style: { fontSize: '1.2rem' } },
    h("p", { part: text }, errorMessage)));
const DetailSectionTitle = (props) => (h("h2", { part: heading2, class: "mt-4 fs-5 border-bottom pb-3" }, props.sectionTitle));
const DetailItem = ({ title, value, }) => title && value ? (h("div", { class: "d-table-row gap-2" },
    h("span", { class: "fw-bold d-table-cell px-2", part: text }, title),
    h("span", { class: "flex-1 d-table-cell px-2 text-wrap", part: text }, value))) : null;
const EntityHeadInfoItem = ({ title, value, classes, }) => (h("div", { class: `d-flex flex-column ${classes}` },
    h("span", { class: "fw-bold border-1 border-bottom ps-2 pe-2", part: heading2 }, title),
    h("span", { class: "pt-2 ps-2 pe-2", part: text }, value)));
const EntityHeadInfo = ({ title, slot, badge }, children) => (h("div", { slot: slot, class: "p-2" },
    h("div", { class: "d-flex flex-row align-items-center gap-2 mb-2" },
        h("h1", { class: "m-0", part: heading1 }, title),
        badge),
    h("div", { class: "d-flex flex-row align-items-top", part: text }, children)));
const CodeBlock = ({ metadata }) => metadata && Object.keys(metadata).length ? (h("div", { class: 'mt-4' },
    h("pre", { class: "p-2", "aria-label": "metadata content" },
        h("code", null, JSON.stringify(metadata, null, 2))))) : null;

export { CodeBlock as C, DetailSectionTitle as D, ErrorState as E, DetailItem as a, EntityHeadInfo as b, EntityHeadInfoItem as c };
